module.exports = __webpack_public_path__ + "img/licence1.fbb62892.jpg";